import { UserState } from "@/core/enums/users";

interface StateInfo {
  color: string;
  label: string;
}

const stateMap: Record<UserState, StateInfo> = {
  [UserState.ACTIVE]: {
    color: "text-green-600",
    label: "Activo",
  },
  [UserState.INACTIVE]: {
    color: "text-gray-600",
    label: "Inactivo",
  },
  [UserState.SUSPENDED]: {
    color: "text-red-600",
    label: "Suspendido",
  },
  [UserState.PENDING]: {
    color: "text-yellow-600",
    label: "Pendiente",
  },
};

/**
 * Obtiene la información del estado de usuario (color y etiqueta en español)
 * @param state - El estado del usuario (debe ser uno de los valores de UserState)
 * @returns Objeto con color (clase CSS) y label (texto en español)
 */
export function getUserStateInfo(state: string): StateInfo {
  // Validar que el estado sea uno de los valores del enum
  const validStates = Object.values(UserState);

  if (!validStates.includes(state as UserState)) {
    // Si no es un estado válido, retornar valores por defecto
    return {
      color: "text-gray-600",
      label: "Desconocido",
    };
  }

  return stateMap[state as UserState];
}

/**
 * Obtiene solo el color del estado
 */
export function getUserStateColor(state: string): string {
  return getUserStateInfo(state).color;
}

/**
 * Obtiene solo la etiqueta en español del estado
 */
export function getUserStateLabel(state: string): string {
  return getUserStateInfo(state).label;
}
